export const apiUrls = {
    signup: 'signup',
    login: "login",
    logout: "logout",
    categoryListing: "category-listing",
    sizesListing: 'sizes-listing',
    brandsListing: 'brands-listing',
    brandModelsListing: 'brand-models-listing',
    changePassword: 'change-password',
    editProfile: 'edit-profile',
    updateImage: 'update-image',
    getUser: 'getUser',
    deleteAccount: 'delete-account',
    addressUpdate: 'address/update',
    productListing: 'product-listing',
    featuredProductListing: 'featured-product-listing',
    productDetail: 'product-detail',
    productSave: 'product-save',
    productSaveListing: 'product-save-listing',
    addProductReview: 'add-product-review',
    productSearch: 'product-search',
    productReviews: 'product-reviews',
    addToCart: 'add-to-cart',
    getCartList: 'cart-list',
    updateCartItem: 'update-cart',
    removeFromCart: 'delete-cart',
    testimonialListing: 'testimonial-listing',
    forgotPasswordSendMail: 'forgot-password-sentmail',
    forgotPasswordVerifyOTP: 'forgot-password-verifyotp',
    resetPassword: 'reset-password',
    logoListing: 'logo-listing',
    contactSave: 'contact-save',
    contentPageListing: 'content-page-listing',
    contentPageDetail: 'content-page-detail',
    authGoogle: 'auth/google',
    footerSetting: 'footer-setting',
    addReview: 'add-review',
    marketingHighlights: 'marketing-highlights',
    contactPageDetail: 'contact-page-detail',
    aboutPageDetail: 'about-page-detail',
    checkoutEstimate: 'checkout/estimate',
    checkoutItems: 'checkout/items',
    paypalSession: 'checkout/paypal_payment',
    checkoutPaypalVerify: 'checkout/paypal_verify',
    ordersOrderListing: 'orders/order-listing',
    orderDetail: 'orders/order-detail',
    orderInvoice: 'orders/order-invoice',
    orderStatus: 'orders/order-status',
};
